// extracted by mini-css-extract-plugin
export default {"container":"rM-z","topReviewHeading":"sM-z","criticalReview":"tM-z","favorableReview":"uM-z","vsSeparator":"vM-z"};